module.exports = __webpack_public_path__ + "static/media/Charity Excerpt Translated by J_Lee_77777.be2bea7e.md";